import { render } from "./index.vue?vue&type=template&id=38e5bd8a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=38e5bd8a&lang=scss&scoped=true"

import exportComponent from "D:\\project\\dongmeng\\meeting-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e5bd8a"]])

export default __exports__